import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Avatar from '../Avatar';
import { Link } from '@paypalcorp/pp-react-links';
import { BodyText } from '@paypalcorp/pp-react-text';
import templateData, { localsMessages } from '../../utility/getTemplateData';
import { showSpinnerOverlay } from '../../utility/helper';
import { getHardLogoutUrl, isOneTouchUser } from '../../utility/authUtils';
import { sanitize } from '../../utility/domUtils';
import getContent from 'pp-react-l10n';
import { isExternalFlow } from '../../utility/externalIntegrationUtils';
import BackButton from '../BackButton';
import { appendCdnHostName } from '../../utility/geoUtils';
import { isInContext } from '../../utility/inContextDonation';
import { trackLinkClick } from '../../fpti/fpti';
import { FPTI_TAGS, LINK_NAME } from '../../fpti/fptiConstants';
import _isEmpty from 'lodash/isEmpty';
import classNames from 'classnames';

const messages = localsMessages('common/oneTouch');
const PROFILE_PHOTO_PLACEHOLDER = appendCdnHostName(
  '/images/shared/icon_profile_placeholder@2x.png'
);

class UserDetailsBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bannerUrl: templateData.bannerUrl,
      showCCErrorMessage: templateData.showCCErrorMessage,
    };
  }
  static propTypes = {
    userDetails: PropTypes.object,
  };

  createLoggedInMessage = (firstName) => {
    const getOneTouchMessage = getContent('locals')('common/oneTouch');
    return isOneTouchUser()
      ? getOneTouchMessage(
          'banner.oneTouchGreeting',
          {
            firstName: sanitize(firstName),
          },
          { useHTML: true }
        )
      : getOneTouchMessage('banner.fullLoginGreeting', {
          firstName: sanitize(firstName),
        });
  };

  handleNotYouLinkClick = () => {
    showSpinnerOverlay();
    trackLinkClick(LINK_NAME.NOT_YOU, {
      additionalData: {
        [FPTI_TAGS.AUTH_STATE]: templateData.authState,
        [FPTI_TAGS.VERSION]: templateData.sessionDeprecationEnabled
          ? 'V2'
          : 'V1',
      },
    });
    this.logout();
  };

  logout = () => {
    window.location.href = getHardLogoutUrl();
  };

  determineUserDetailsBannerClass() {
    let backgroundImageExists = !_isEmpty(this.state.bannerUrl);
    return classNames({
      gn_user_details_banner: isExternalFlow() && !backgroundImageExists,
      gn_user_details_banner_no_border:
        isExternalFlow() && backgroundImageExists,
      user_details_banner: !isExternalFlow() && !backgroundImageExists,
      user_details_banner_no_border: !isExternalFlow() && backgroundImageExists,
    });
  }

  render() {
    const { userDetails = {} } = this.props;
    const firstName = userDetails.firstName || '';
    const profilePhotoUrl =
      userDetails.thumbnailUrl || PROFILE_PHOTO_PLACEHOLDER;
    const loggedInMessage = this.createLoggedInMessage(firstName);
    const isLandingPage = templateData.viewName === 'landing';
    const shouldShowBackButton =
      ((isInContext() && !this.state.showCCErrorMessage) || isExternalFlow()) &&
      !isLandingPage;

    return (
      <div className={this.determineUserDetailsBannerClass()}>
        {shouldShowBackButton && (
          <BackButton inverse={templateData.hasBanner} />
        )}
        <Avatar thumbnailUrl={profilePhotoUrl} />
        <div className="details-container">
          <div className="details">
            <BodyText className="hi-msg">{loggedInMessage}</BodyText>
            <div className="not-you-link">
              <Link href="#" onClick={this.handleNotYouLinkClick}>
                {messages.banner.notYou}
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default UserDetailsBanner;
